module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" Dashboard\n                  ")])], 1), _vm._v(" "), (_vm.permissions.indexOf('timetracking_task_read') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(time-sheets)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/time-sheets',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Time Sheet\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_all_my_tasks') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('/workflow/all-my-tasks')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/workflow/all-my-tasks',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" My Tasks\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_all_workflow_tasks') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('/workflow/all-tasks')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/workflow/all-tasks',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" All Tasks\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('client_read') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(clients)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clients',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Clients\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('see_all_deadlines') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(deadlines)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/deadlines',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadlines\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('reports_read') >= 0) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.isActiveMenuGroup(_vm.reports_paths)
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/reports/user-tasks',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" User Tasks\n                          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/completed-tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/reports/completed-tasks',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Completed Tasks\n                          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/client-revenue)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/reports/client-revenue',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Client Revenue\n                          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(reports/weekly-time)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/reports/weekly-time',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Weekly Time\n                          ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('company_management') >= 0) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.isActiveMenuGroup(_vm.settings_paths)
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(settings)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/settings'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Settings\n                      ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(users)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/users'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Manage Users\n                      ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(roles)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/roles'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Manage Roles\n                      ")])], 1), _vm._v(" "), (_vm.permissions.indexOf('timetracking_cost_type_read') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(fee-types)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/fee-types',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Fee Type\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('timetracking_task_type_read') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(task-types)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/task-types',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Task Type\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_checklist_index') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(checklists)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/checklists',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Checklists\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_index') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('/workflow')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/workflow',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-recycle"
  }), _vm._v(" Workflow templates\n                      ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-wrench"
  }), _vm._v("Settings")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "http://optimpractice.com/support",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" Support\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "http://optimpractice.com/getting-started",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-rocket"
  }), _vm._v(" Getting Started\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bba85ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 587
// module chunks = 81